import React, { FunctionComponent, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { parse } from 'query-string';
import { injectIntl, IntlShape } from 'react-intl';
import NotFound from '../../scenes/NotFound';
import Survey from '../../scenes/SurveyUI/containers/Survey';
import { getObject, setObject } from '../../common/helpers/storageHelper';
import { setPreviewDataRoutine } from '../../scenes/SurveyUI/routines';
import { IBindingCallback1 } from '../../common/models/callback';
import { IReferenceSurvey } from '../../common/models/reference/IReferenceSurvey';
import { IPreviewQuestion } from '../../common/models/question/IPreviewQuestion';
import { IAppState } from '../../common/models/store/IAppState';
import { ReferenceType } from '../../common/enums/ReferenceType';
import { ICandidateName } from '../../common/models/candidate/ICandidateName';
import LoaderWrapper from '../../components/LoaderWrapper';
import { User } from '../../common/models/user/User';

interface IProps extends RouteComponentProps {
  user: User;
  intl: IntlShape;
  surveyCandidateId: string;
  workspaceName: string;
  setPreviewData: IBindingCallback1<{
    reference: Partial<IReferenceSurvey>;
    questions: IPreviewQuestion[];
    candidate: ICandidateName;
  }>;
}

const SurveyPreview: FunctionComponent<IProps> = ({
  user,
  intl,
  location,
  workspaceName,
  surveyCandidateId,
  setPreviewData
}) => {
  const [isLoading, setIsLoading] = useState(true);

  const { id } = parse(location.search);
  const surveyPreviewData = getObject('surveyPreview');

  const surveyQuestions = surveyPreviewData && surveyPreviewData[id as string];

  useEffect(() => {
    if (surveyQuestions) {
      setPreviewData({
        reference: {
          firstName: user.firstName,
          lastName: user.lastName,
          phoneNumber: user.phoneNumber,
          email: user.email,
          workInCompany: `[${intl.formatMessage({ id: 'candidateForm.company', defaultMessage: 'Company name' })}]`,
          type: ReferenceType.Manager,
          title: `[${intl.formatMessage({ id: 'survey.refTitle', defaultMessage: 'Your title' })}]`,
          workStartDate: new Date()
        },
        questions: surveyQuestions,
        candidate: {
          id: id as string,
          firstName: `[${intl.formatMessage({ id: 'firstName', defaultMessage: 'First name' })}]`,
          lastName: `[${intl.formatMessage({ id: 'lastName', defaultMessage: 'Last name' })}]`
        }
      });
      setObject('surveyPreview', { ...surveyPreviewData, [id as string]: undefined });
    }
  }, []);

  useEffect(() => {
    setIsLoading(false);
    if (surveyCandidateId === id) {
      window.Beacon('destroy');
    }
  }, [surveyCandidateId]);

  return (
    <LoaderWrapper loading={isLoading}>
      {surveyCandidateId === id ? <Survey isPreview /> : <NotFound />}
    </LoaderWrapper>
  );
};

const mapStateToProps = ({
  user: { user },
  refSurvey: { candidate: { id } },
  workspace: { name }
}: IAppState) => ({ user: user as User, surveyCandidateId: id, workspaceName: name });

const mapDispatchToProps = {
  setPreviewData: setPreviewDataRoutine
};

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(withRouter(SurveyPreview)));
